import { useEffect, useState } from 'react'
import { Dataset, DatesetControllerApi, GetDatasetVersionsResponse } from '../../../api/generated'
import DATASETS_MOCK from './../mocks/datasets.mock.json'

export const apiClient = new DatesetControllerApi()

export const useDatasets = () => {
  const [data, setData] = useState<GetDatasetVersionsResponse['datasets'] | []>([])
  const [activeDataset, setActiveDataset] = useState<Dataset | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | string | null>(null)

  const fetchDatasetVersions = async () => {
    setLoading(true)
    setError(null)

    try {
      const delay = 1000 * Math.floor(Math.random() * 4) + 1
      const mock: GetDatasetVersionsResponse = await new Promise(resolve => setTimeout(resolve, delay, DATASETS_MOCK))

      if (mock) return setData(mock?.datasets)

      const response = await apiClient.getDatasetVersionsRaw()
      const jsonData = await response.value()
      setData(jsonData.datasets || [])
    } catch (err: unknown) {
      setError((err as Error)?.message || 'An unknown error occurred')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDatasetVersions()
  }, [])

  useEffect(() => {
    if (activeDataset && data[0]) {
      setActiveDataset(activeDataset)
    }
  }, [data])

  return { data, activeDataset, loading, error }
}
